import React from 'react'
import { TrackableSellableFragment } from '../../../../../fragments/TrackableSellable.generated'
import { OrderLineItemFragment } from '../../../../../fragments/OrderLineItem.generated'
import ProductLineItemGroup from '../ProductLineItemGroup'
import { groupLineItems } from '#src/services/cart'

interface Props {
  lineItems: OrderLineItemFragment[]
  onRemoveItem: (lineItemId: string, sellable?: TrackableSellableFragment) => void
  onUpdateQuantity: (lineItemId: string, quantity: number) => void
  loadingUpdateQuantity: boolean
}

// This compoennt will be usefil if we ever want to split how we render different line item groups
const LineItems: React.FC<Props> = ({
  lineItems,
  onRemoveItem,
  onUpdateQuantity,
  loadingUpdateQuantity
}) => {
  const groupedLineItems = groupLineItems({ lineItems: lineItems })
  return (
    <div>
      {groupedLineItems.map(group => {
        return (
          <ProductLineItemGroup
            key={group.parentLineItem.id}
            group={group}
            onRemoveItem={onRemoveItem}
            onUpdateQuantity={onUpdateQuantity}
            loadingUpdateQuantity={loadingUpdateQuantity}
          />
        )
      })}
    </div>
  )
}

export default LineItems
